export default __webpack_public_path__ + "static/media/daub.16e33752.png";